// Account-level billing paths. These are plain strings (not typed `router.buildLocation` targets)
// because the per-tab TanStack routes are migrated in later tickets (SPE-3765–3770); each href
// converts to a typed route reference as its tab lands.
export const BILLING_BASE = '/settings/billing';

export const BILLING_PATHS = {
  yourPlan: `${BILLING_BASE}/your-plan`,
  llmUsage: `${BILLING_BASE}/llm-usage`,
  inboxPreviewUsage: `${BILLING_BASE}/inbox-preview-usage`,
  profileGrowth: `${BILLING_BASE}/profile-growth`,
  billingHistory: `${BILLING_BASE}/billing-history`,
  paymentMethods: `${BILLING_BASE}/payment-methods`,
  availablePlans: `${BILLING_BASE}/available-plans/journeys`,
  checkout: `${BILLING_BASE}/checkout`,
};

/**
 * The query param a completed upgrade hands to the home page so it can celebrate (SPE-3957). It
 * carries the plan that was bought rather than a bare flag, so a later tier gets its own copy
 * instead of inheriting the Essentials wording.
 */
export const UPGRADED_PARAM = 'upgraded';
export const UPGRADED_TO_ESSENTIALS = 'essentials';

/** The workspace-home route a completed upgrade lands on, for `router.buildLocation`. */
export const WORKSPACE_HOME_ROUTE = '/workspaces/$workspaceId/home';
